export const translations = {
  es: {
    info: "Información",
    also_visit: "También puedes visitar",
    select_region: "Seleccionar región",
    language: "Idioma",
    spanish: "Español",
    english: "Inglés",
    south_america: "Sudamérica",
    europe: "Europa",
    north_america: "Norteamérica",
    middle_east: "Medio Oriente",
    brand: "La Mar",
    reservations: "Reservas",
    locations: "Ubicaciones",
    about: "La Mar",
    news: "Noticias",
    help: "Ayuda y legal",
    job_positions: "Trabaja con nosotros",
    terms_conditions: "Términos y condiciones",
    privacy_policy: "Política de privacidad",
    california_residents: "Residentes de California",
    uk_residents: "Residentes del Reino Unido",
    visit: "Visitar",
    schedule: "Horario",
    address: "Dirección",
    phone: "Teléfono",
    email: "Correo",
    copyright:
      "Todos los derechos reservados a “Acurio International” & “Acurio Restaurantes”",
    more_options: "Más opciones",
    more: "Más",
    view_more: "Ver más",
    learn_more: "Leer más",
  },
  en: {
    info: "Information",
    also_visit: "You can also visit",
    select_region: "Select region",
    language: "Language",
    spanish: "Spanish",
    english: "English",
    south_america: "South America",
    europe: "Europe",
    north_america: "North America",
    middle_east: "Middle East",
    brand: "The Brand",
    reservations: "Reservations",
    locations: "Locations",
    about: "About",
    news: "News",
    help: "Help and Legal",
    job_positions: "Job Positions",
    terms_conditions: "Terms & Conditions",
    privacy_policy: "Privacy Policy",
    california_residents: "California Residents",
    uk_residents: "UK Residents",
    visit: "Visit website",
    schedule: "Schedule",
    address: "Address",
    phone: "Phone",
    email: "Email",
    copyright:
      "All rights reserved “Acurio International” & “Acurio Restaurantes”",
    more_options: "More options",
    more: "More",
    view_more: "View more",
    learn_more: "Learn more",
  },
};
